/**
 * Feb 2026 · /enquire-w/:slug — Public embeddable widget landing page.
 *
 * Fetches the widget definition (workspace + types + style) via
 * /public/enquiry-widgets/:slug and re-uses <EnquiryWidgetView /> to
 * render the intake flow with the widget's saved style overrides.
 */
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "@/lib/api";
import { apiErrorMessage } from "@/lib/apiError";
import { toast } from "sonner";
import { EnquiryWidgetView } from "./EnquiryWidget";

export default function EnquiryWidgetSlug() {
  const { slug } = useParams();
  const [state, setState] = useState({ loading: true, cfg: null, style: null, wsId: null, error: null });

  useEffect(() => {
    if (!slug) return;
    api.get(`/public/enquiry-widgets/${slug}`)
       .then((r) => {
         setState({
           loading: false,
           cfg: {
             workspace: r.data.workspace,
             types: r.data.types || [],
             pinned: (r.data.types || []).length === 1,
           },
           style: r.data.widget?.style || {},
           wsId: r.data.workspace?.id,
           error: null,
         });
       })
       .catch((e) => {
         setState({ loading: false, cfg: null, style: null, wsId: null,
                    error: apiErrorMessage(e, "Widget not found") });
         toast.error(apiErrorMessage(e, "Widget not found"));
       });
  }, [slug]);

  if (state.loading) {
    return <div style={{ padding: 40, fontFamily: "system-ui" }} data-testid="enq-widget-slug-loading">Loading…</div>;
  }
  if (state.error) {
    return (
      <div style={{ padding: 60, textAlign: "center", fontFamily: "system-ui" }} data-testid="enq-widget-slug-error">
        <h1 style={{ fontSize: 28, marginBottom: 8 }}>Widget unavailable</h1>
        <p style={{ color: "#666" }}>{state.error}</p>
      </div>
    );
  }
  return <EnquiryWidgetView cfg={state.cfg} wsId={state.wsId}
                              styleOverride={state.style}
                              sourceLabel={`widget:${slug}`}
                              submitEndpoint={`/public/enquiry-widgets/${slug}/submit`} />;
}
